// extracted by mini-css-extract-plugin
export var headerNavTop = "layout-module--headerNavTop--AUOvC";
export var headerNavBottom = "layout-module--headerNavBottom--6+0Sd";
export var menuButton = "layout-module--menuButton--daa1O";
export var menuBottom = "layout-module--menuBottom--1K7ZW";
export var header = "layout-module--header--aoaNz";
export var headerLogo = "layout-module--headerLogo--jzQxv";
export var headerNav = "layout-module--headerNav--xOYHP";
export var GalleryImageContainer = "layout-module--GalleryImageContainer--XhwfB";
export var BackgroundLayer = "layout-module--BackgroundLayer--MWBhY";